import React from "react";
import theme from "../../../styles/theme";



const Page33 = () => {
  return (

    <div>
    <h2>"Page 33" </h2>
    </div>

  );
};

export default Page33;
